// extracted by mini-css-extract-plugin
export default {"backdrop":"AddNew_backdrop__JFHSR","modal":"AddNew_modal__bywOC","form":"AddNew_form__KSh7s","input":"AddNew_input__La45k","button":"AddNew_button__bohwH"};